import {connectPaymentsSvg as Icon__small__connectPaymentsSvg} from '../Icon__small/Icon__small--connectPayments.js'

export var connectPayments = {
  name: 'connectPayments',
  category: 'icon',
  colorable: true,
  svg: Icon__small__connectPaymentsSvg,
};
